import { DATA_ORGA_LN_MODEL , LOCATE_ENDPOINT_VIEWEACH_KINDLAB , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";

export default {
    namespaced: true,

    state: {

        buffORGADatPrepareDat : "",
        buffORGADatCtDat : "",
        dataORGASpecLN: Object.assign( {} ,DATA_ORGA_LN_MODEL) ,

        mstOrgaDat: [] ,
        mstDrugDat: [] ,
        mstMicDat  : [] ,
        mstResultDat: [],
        mstMethod:[],
        mstMethodResult:[],
        tmplateOrga:{}
    },

    getters: {

    },

    mutations: {
        setMstMethod (state, mstMethod) {
            state.mstMethod = mstMethod
        },


        setMstMethodResult (state, mstMethodResult) {
            state.mstMethodResult = mstMethodResult
        },




        setTmplateOrga (state, tmplateOrga) {
            state.tmplateOrga = tmplateOrga
        },


        setMstResultDat (state, mstResultDat) {
            state.mstResultDat = mstResultDat
        },

        setMstMicDat (state, mstMicDat) {
            state.mstMicDat = mstMicDat
        },

        setMstDrugDat (state, mstDrugDat) {
            state.mstDrugDat = mstDrugDat
        },

        setMstOrgaDat (state, mstOrgaDat) {
            state.mstOrgaDat = mstOrgaDat
        },


        setDataORGASpecLN (state, dataORGASpecLN) {
            state.dataORGASpecLN = dataORGASpecLN
        },

        setBuffORGADatPrepareDat (state, buffORGADatPrepareDat) {
            state.buffORGADatPrepareDat = buffORGADatPrepareDat
        },

        setBuffORGADatCtDat (state, buffORGADatCtDat) {
            state.buffORGADatCtDat = buffORGADatCtDat
        },

    },

    actions: {
        
        // Dev experiment: HTTP-complete actions; legacy actions below are unchanged.
        fetchMiscMasterDataForOrgaSequential({
          commit
        }, datTo) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/get_misc_masterdata_for_orga`, datTo, getConfigAxios()).then(res => {
            commit('setMstResultDat', res.data.result_mst);
            commit('setMstMicDat', res.data.mic);
            commit('setMstDrugDat', res.data.drug);
            commit('setMstOrgaDat', res.data.orga);
            commit('setTmplateOrga', res.data.tmplate);
            commit('setMstMethod', res.data.method_mst);
            commit('setMstMethodResult', res.data.method_result_mst);
            return res.data;
          });
        },
produceDoneFetching({commit},doneFetching){
            commit('setDoneFetching', doneFetching)
        },

        produceBuffORGADatPrepareDat({commit},buffORGADatPrepareDat){
            commit('setBuffORGADatPrepareDat', buffORGADatPrepareDat)
        },

        produceBuffORGADatCtDat({commit},buffDatCtDat){
            commit('setBuffORGADatCtDat', buffDatCtDat)
        },



        fetchMiscMasterDataForOrga({commit},datTo) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_misc_masterdata_for_orga`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setMstResultDat', res.data.result_mst)
                        commit('setMstMicDat', res.data.mic)
                        commit('setMstDrugDat', res.data.drug)
                        commit('setMstOrgaDat', res.data.orga)
                        commit('setTmplateOrga', res.data.tmplate)
                        commit('setMstMethod', res.data.method_mst)
                        commit('setMstMethodResult', res.data.method_result_mst)

                        resolve(res.data)
                    })
            }    )

        },


        fetchORGAOLDDat({commit}, payload) {
            const {shouldApply, ...datTo} = payload
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
            return axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.ORGANISM}`, datTo, getConfigAxios())
                .then(res => {
                    const prepare = res.data.dat_prepare.dat == null ? '' : Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8')
                    const ct = res.data.dat_ct.dat == null ? '' : Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8')
                    if (shouldApply && !shouldApply()) return res.data
                    commit('setDataORGASpecLN', JSON.parse(JSON.stringify(res.data)))
                    commit('setBuffORGADatPrepareDat', prepare)
                    commit('setBuffORGADatCtDat', ct)
                    return res.data
                })
        }

    }
}